import { Table, Row, Col, Button, Tooltip, Popconfirm, Tag } from "antd";
import { FaTrash, FaPhoneAlt } from "react-icons/fa";
import { FaRegEye, FaRegPenToSquare, FaClockRotateLeft } from "react-icons/fa6";
import "./ParticipantesTable.css";

export function ParticipantesTable({
  participants,
  loading,
  page,
  total,
  pageSize,
  setPage,
  permissionUpdate,
  permissionDelete,
  handleView,
  handleEdit,
  handleViewCallHistory,
  canAddCall,
  getCallLabel,
  handleAddCall,
  getRealStatus,
  statusColors,
  handleDelete,
  getNextCallNumber
}) {

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      render: (_, r) => `${r.nombre} ${r.apellido}`,
    },
    {
      title: "Identificación",
      dataIndex: "identificacion",
      key: "identificacion",
      width: 120,
    },
    {
      title: "Género",
      dataIndex: "sexo",
      align: "center",
      key: "sexo",
      width: 120,
      render: (sexo) => (sexo === "M" ? "Masculino" : "Femenino"),
    },
    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
      width: 120,
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
      width: 120,
    },
    {
      title: "Teléfono",
      dataIndex: "telefono",
      key: "telefono",
      width: 100,
    },
    {
      title: "Progreso",
      key: "progreso",
      align: "center",
      width: 170,
      render: (_, record) => {
        const status = getRealStatus(record);
        const color = statusColors[status];
        const label =
          status === "En Proceso"
            ? `Intentos: ${record.total_llamadas}/3`
            : status;

        return (
          <Tag
            color={color}
            style={{
              fontSize: 13,
              width: 115,
              padding: "3px 7px",
              borderRadius: 6,
            }}
          >
            <FaPhoneAlt style={{ marginRight: 6 }} />
            {label}
          </Tag>
        );
      },
    },
    {
      title: "Acciones",
      key: "acciones",
      align: "center",
      width: 230,
      render: (_, record) => {
        const status = getRealStatus(record);
        const normalized = status
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .trim();
        const isBlocked =
          normalized === "verificado" || normalized === "no continua";
        return (
          <Row gutter={8} justify="center" className="participantes-actions">
            <Col>
              <Tooltip title="Ver detalles">
                <Button
                  type="text"
                  size="small"
                  className="action-btn"
                  icon={<FaRegEye />}
                  onClick={() => handleView(record)}
                />
              </Tooltip>
            </Col>
            {permissionUpdate && (
              <Col>
                <Tooltip title="Editar participante">
                  <Button
                    type="text"
                    size="small"
                    className="action-btn"
                    icon={<FaRegPenToSquare />}
                    onClick={() => handleEdit(record)}
                  />
                </Tooltip>
              </Col>
            )}
            <Col>
              <Tooltip
                title={
                  record.total_llamadas > 0
                    ? "Ver historial de llamadas"
                    : "Sin registros de llamadas"
                }
              >
                <Button
                  type="text"
                  size="small"
                  className={`action-btn ${
                    record.total_llamadas === 0 ? "history-disabled" : ""
                  }`}
                  icon={<FaClockRotateLeft />}
                  disabled={record.total_llamadas === 0}
                  onClick={() => handleViewCallHistory(record)}
                />
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title={getCallLabel(record)}>
                <Button
                  type="text"
                  size="small"
                  className={`action-btn ${
                    isBlocked ? "call-disabled" : "call-icon"
                  }`}
                  icon={<FaPhoneAlt />}
                  disabled={isBlocked || !canAddCall(record)}
                  onClick={() => handleAddCall(record)}
                />
              </Tooltip>
            </Col>
            {permissionDelete && (
              <Col>
                <Popconfirm
                  title="¿Eliminar participante?"
                  description="Este participante será marcado como eliminado."
                  okText="Sí, eliminar"
                  cancelText="Cancelar"
                  onConfirm={() => handleDelete(record.id)}
                >
                  <Button
                    type="text"
                    size="small"
                    className="action-btn delete-icon action-btn-danger"
                    icon={<FaTrash />}
                  />
                </Popconfirm>
              </Col>
            )}
          </Row>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={participants}
      loading={loading}
      rowKey="id"
      bordered
      size="small"
      sticky
      scroll={{ x: "max-content" }}
      pagination={{
        current: page,
        total,
        pageSize,
        onChange: setPage,
        position: ["bottomRight"],
        showSizeChanger: false,
      }}
      style={{
        borderRadius: 12,
        background: "#fff",
        marginTop: 20,
      }}
    />
  );
}
